import { createGetPropGetter } from '@/store/utils';

export default {
  insights: createGetPropGetter('insights', []),
  insightsLoading: createGetPropGetter('insightsLoading', false),
  assetCorrelation: createGetPropGetter('assetCorrelation', {}),
  getAssetCorrelationForTld: state => tld => state.assetCorrelation[tld] || {},
};
